import React, {useState} from "react";
import DatePicker from "../../connectui/component/input/calendar/DatePicker";
import DateRangePicker from "connectui/component/input/calendar/DateRangePicker";
const DatePickerExample = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedRange, setSelectedRange] = useState([new Date(), new Date()]);

  return (
    <div>
      <h3>Selected Date: {selectedDate.toDateString()}</h3>
      <DatePicker onDateChange={setSelectedDate} />
      <h3>{"Selected Date Range:"}</h3>
      <h3>
        {selectedRange[0].toDateString()} - {selectedRange[1].toDateString()}
      </h3>
      <DateRangePicker onChange={setSelectedRange} />
    </div>
  );
};

export default DatePickerExample;
